<template>
  <BaseBody>
    <BaseTopBar>
      <BaseTopBarContent className="left">
        {{ $t('sidebar.configuration') }} > {{ $t('sidebar.settings') }}
      </BaseTopBarContent>
    </BaseTopBar>
    <BaseContent :loading="loading">
      <section class="col-12 no-padding">
        <div class="col-md-12 no-padding">
          <section-header :title="$t('message.document')"/>
          <div class="form-row">
            <div class="col-md-6">
              <div
                class="col-md-12 no-padding"
                style="height: 24px;">
                {{ $t('message.usedocumentlog') }}
              </div>
              <div
                class="form-group col-12 mb-0"
                style="padding: 0;">
                <div class="form-row no-padding no-margin">
                  <div
                    class="form-group col-6"
                    style="padding: 0;">
                    <div
                      class="box-input"
                      style="border-radius: 0;">
                      <vs-checkbox
                        v-model="settings.log_topic.is_active"
                        color="#A3CA76"
                        style="float: left;position: relative;top: 1px;left: -5px;"
                      >
                        <span v-if="!settings.log_topic.is_active">{{ $t('message.disabled') }}</span>
                        <span v-else>{{ $t('message.enabled') }}</span>
                      </vs-checkbox>
                    </div>
                  </div>
                  <div
                    class="form-group col-6"
                    style="padding-left: 0;padding-right: 0;"
                  >
                    <div
                      class="box-input active"
                      style="
                          border-radius: 0px .25rem .25rem 0;
                          border-left: 0;
                          padding-right: 3px;
                          display: flex;
                          justify-content: space-between;
                          align-items: center;
                        "
                    >
                      <span/>
                      <button
                        class="btn btn-light"
                        style="height: 28px;font-size: 11px;box-shadow: none;"
                        @click="handleOpenLogTipicMasterData"
                      >
                        {{ $t('message.managemasterdata', { number: settings.log_topic.options.length }) }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="form-row">
            <div class="col-md-6">
              <div
                class="col-md-12 no-padding"
                style="height: 24px;">
                {{ $t('message.usedocumentattachfile') }}
              </div>
              <div
                class="form-group col-12 mb-0"
                style="padding: 0;">
                <div class="form-row no-padding no-margin">
                  <div
                    class="form-group col-12"
                    style="padding: 0;">
                    <div class="box-input">
                      <vs-checkbox
                        v-model="settings.attach_file.is_active"
                        color="#A3CA76"
                        style="float: left;position: relative;top: 1px;left: -5px;"
                      >
                        <span v-if="!settings.attach_file.is_active">{{ $t('message.disabled') }}</span>
                        <span v-else>{{ $t('message.enabled') }}</span>
                      </vs-checkbox>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <BaseFormAction
        :textSubmit="$t('button.save')"
        :isSubmitted="isSubmitted"
        @onSubmit="handleSubmit"
      />

      <BaseConfirmDiscardModal
        :show="confirmDiscardModal.show"
        @onCancel="handleDiscardCancleModal"
        @onConfirm="handleDiscardConfirmModal"
      />

      <BaseModalCustomMasterData
        :list="settings.log_topic.options"
        :id="MODAL_LOG_TOPIC_MASTER_DATA"
        :headerText="$t('message.managetopicoptions')"
        :showCheckboxDefault="false"
        @onClose="handleCloseLogTopicMasterData"
        @onSubmit="handleSubmitLogTopicMasterData"
      />
    </BaseContent>
  </BaseBody>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import sidebarModule from './../../sidebarModule'
import submenuModule from '../submenuModule'
import discardFormMixin from '@/mixins/discardForm'

export default {
  mixins: [discardFormMixin],

  data () {
    return {
      MODAL_LOG_TOPIC_MASTER_DATA: 'MODAL_LOG_TOPIC_MASTER_DATA',
      loading: true,
      isSubmitted: false,
      settings: {},
      originalSettings: {},
    }
  },

  computed: {
    ...mapGetters({
      warehouses: 'getWarehouses',
      sidebar: 'getSidebar',
      getInventorySetting: 'getInventorySetting',
    }),
    form () {
      return {
        settings: this.settings,
      }
    },
  },

  watch: {
    warehouses () {
      sidebarModule.init(_.cloneDeep(require('../sidebar.json')))
      sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
      sidebarModule.active({
        sidebarAtIdx: 9,
        submenuAtIdx: 0,
      })
    },
  },

  async created () {
    this.settings = _.cloneDeep(this.getInventorySetting)
    this.originalSettings = _.cloneDeep(this.getInventorySetting)
    await this.fetchData()
  },

  beforeMount () {
    // init page
    this.initPage({
      section: 'app',
      name: this.$t('app.inventory.title'),
      current: {
        app_name: 'inventory',
        app_id: 3,
        module_id: 10,
      },
    })
    // set sidebar stockcontrols ui
    sidebarModule.init(this.getObject(require('../sidebar.json')))
    sidebarModule.update(this.sidebar, 1, submenuModule.getWarehouses(this.warehouses))
    sidebarModule.active({
      sidebarAtIdx: 9,
      submenuAtIdx: 0,
    })
  },

  destroyed () {
    this.leavePage(this.$Progress, [])
  },

  methods: {
    ...mapActions([
      'updateSettingsInventory',
    ]),
    async fetchData () {
      this.loading = true
      await Promise.all([
        this.$store.dispatch('getWarehouses'),
      ])
      this.loading = false
      this.showFinish(this.$Progress)
    },
    async handleSubmit() {
      this.isSubmitted = true
      const response = await this.updateSettingsInventory(this.settings)
      if (response.success) {
        this.notify(this.$vs, {
          text: this.$t('message.saved'),
          color: 'success',
          icon: 'cloud',
        })
        this.showFinish(this.$Progress)
        this.isSubmitted = false
      }
    },
    handleOpenLogTipicMasterData() {
      $(`#${this.MODAL_LOG_TOPIC_MASTER_DATA}`).modal('show')
    },
    handleCloseLogTopicMasterData() {
      this.settings.log_topic.options = _.cloneDeep(this.originalSettings.log_topic.options)
      $(`#${this.MODAL_LOG_TOPIC_MASTER_DATA}`).modal('hide')
    },
    async handleSubmitLogTopicMasterData(payload) {
      this.settings.log_topic.options = _.cloneDeep(payload)
      this.originalSettings.log_topic.options = _.cloneDeep(payload)
      $(`#${this.MODAL_LOG_TOPIC_MASTER_DATA}`).modal('hide')
    },
  },
}
</script>

<style scoped>
.box-input {
  position: relative;
  padding-left: 7px;
  height: 35px;
  background: #fff;
  border: 1px solid #ced4da;
  color: #495057;
  line-height: 35px;
  border-radius: .25rem;
  display: inline-block;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.box-input.active {
  background: #e9ecef;
  border-radius: .25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/apps/inventory/configuration/Setting.vue